import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { blueGrey, grey, yellow } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import { deleteVar, getVar } from "../../http/api/VarAPI";
import { CompanyTitledPage } from "../TitledPage";
import SearchForm from "./SearchForm";
import useInputObject from "../../hooks/useInputObject";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";

const infoTableCellSx = {
  fontSize: 17,
};

const VarPage = () => {
  const columns = [
    "変数区分",
    "変数コード",
    "変数値1",
    "変数値2",
    "変数値3",
    "変数値4",
    "表示順",
    "",
  ];
  const [listVar, setListVar] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const varDivLocation = location.state ? location.state.varDiv : 1;
  const searchData = useInputObject({ varDiv: 1 });
  const deleteDialog = useInputObject({ open: false, deleteItem: {} });

  useEffect(() => {
    if (!varDivLocation) return;
    searchData.update("varDiv", varDivLocation);
  }, [varDivLocation]);

  useEffect(() => {
    handleSearch(searchData.Value);
  }, [searchData.Value]);

  async function handleSearch(searchData) {
    try {
      const response = await getVar(searchData);
      setListVar(response.listVarInfo);
    } catch {
      setListVar([]);
    }
  }
  async function onClickDeleteVar(data) {
    deleteDialog.updates({ open: true, deleteItem: data });
  }

  function deleteSelectedVar() {
    const deleteVarDiv = deleteDialog.Value.deleteItem.varDiv;
    const deleteVarCd = deleteDialog.Value.deleteItem.varCd;
    const userDelete = 1; //TODO : JWT
    const deleteParams = {
      varDiv: deleteVarDiv,
      varCd: deleteVarCd,
      updatedId: userDelete,
    };
    try {
      deleteVar(deleteParams);
      alert("変数を削除しました。");
      const newListVar = listVar.filter(
        (v) => !(v.varDiv === deleteVarDiv && v.varCd === deleteVarCd)
      );
      setListVar(newListVar);
    } catch {
      alert("変数を削除できませんでした。");
    }
  }

  return (
    <Fragment>
      <CompanyTitledPage title="変数管理">
        <SearchForm searchData={searchData} search={handleSearch} />

        <CompanyPartHeader>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            my={1}
          >
            <Grid item xs="auto">
              <Typography fontWeight="bold" fontSize={20}>
                検索一覧
                {listVar.length > 0 ? `（件数：${listVar.length}）` : ""}
              </Typography>
            </Grid>
            <Grid item xs="auto">
              <Button
                variant="outlined"
                onClick={() =>
                  navigate(`/company/var_insert/`, {
                    state: { varDiv: searchData.Value.varDiv },
                  })
                }
              >
                変数を登録
              </Button>
            </Grid>
          </Grid>
        </CompanyPartHeader>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {columns.map((columnName, i) => {
                  return (
                    <TableCell
                      key={`${columnName}_${i}`}
                      sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                    >
                      {columnName}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {listVar.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: blueGrey[50],
                    },
                  }}
                >
                  {/*  */}
                  <TableCell sx={{ ...infoTableCellSx, width: 70 }}>
                    {data.varDiv}
                  </TableCell>
                  {/* 中分類 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 70 }}>
                    {data.varCd}
                  </TableCell>
                  {/* 小分類 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 135 }}>
                    {data.varValue1}
                  </TableCell>
                  {/* 税率 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 135 }}>
                    {data.varValue2}
                  </TableCell>
                  {/* 産地 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 135 }}>
                    {data.varValue3}
                  </TableCell>
                  {/* 等級 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 135 }}>
                    {data.varValue4}
                  </TableCell>
                  {/* 産地 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 50 }}>
                    {data.displayOrder}
                  </TableCell>
                  {/* 編集・削除 */}
                  <TableCell sx={{ ...infoTableCellSx, width: 70 }}>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        variant="outlined"
                        sx={{ marginRight: 3 }}
                        onClick={() =>
                          navigate(`/company/var_edit/`, {
                            state: {
                              varDiv: data.varDiv,
                              varCd: data.varCd,
                            },
                          })
                        }
                      >
                        編集
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          onClickDeleteVar(data);
                        }}
                      >
                        削除
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ConfirmDialog
          open={deleteDialog.Value.open}
          onClose={() => deleteDialog.update("open", false)}
          title="変数を削除確認"
          action={deleteSelectedVar}
          buttonAcceptLabel="削除"
        >
          <Box marginTop={2} marginBottom={1}>
            <Typography>以下の変数を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography>
                変数区分：{deleteDialog.Value.deleteItem.varDiv}
              </Typography>
              <Typography>
                変数コード：{deleteDialog.Value.deleteItem.varCd}
              </Typography>
              <Typography>
                変数値1：{deleteDialog.Value.deleteItem.varValue1}
              </Typography>
              <Typography>
                変数値2：{deleteDialog.Value.deleteItem.varValue2}
              </Typography>
              <Typography>
                変数値3：{deleteDialog.Value.deleteItem.varValue3}
              </Typography>
              <Typography>
                変数値4：{deleteDialog.Value.deleteItem.varValue4}
              </Typography>
              <Typography>
                並順：{deleteDialog.Value.deleteItem.displayOrder}
              </Typography>
            </Box>
          </Box>
        </ConfirmDialog>
      </CompanyTitledPage>
    </Fragment>
  );
};
export default VarPage;
